/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class Plus extends React.Component<{ style: any }> {
  render() {
    return <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="currentcolor" {...this.props}>
      <g
        id="plus"
        fillRule="evenodd"
      >
        <g
          id="Group-28"
          transform="translate(12.020815, 12.020815) rotate(-315.000000) translate(-12.020815, -12.020815) translate(3.520815, 3.520815)"
        >
          <path
            d="M1.87522459,0.321737674 L16.6280098,15.0745229 C17.0569934,15.5035064 17.0569934,16.1990262 16.6280098,16.6280098 C16.1990262,17.0569934 15.5035064,17.0569934 15.0745229,16.6280098 L0.321737674,1.87522459 C-0.107245891,1.44624102 -0.107245891,0.750721239 0.321737674,0.321737674 C0.750721239,-0.107245891 1.44624102,-0.107245891 1.87522459,0.321737674 Z"
            id="Rectangle-46"
          />
          <path
            d="M16.6280098,1.87522459 L1.87522459,16.6280098 C1.44624102,17.0569934 0.750721239,17.0569934 0.321737674,16.6280098 C-0.107245891,16.1990262 -0.107245891,15.5035064 0.321737674,15.0745229 L15.0745229,0.321737674 C15.5035064,-0.107245891 16.1990262,-0.107245891 16.6280098,0.321737674 C17.0569934,0.750721239 17.0569934,1.44624102 16.6280098,1.87522459 Z"
            id="Rectangle-46"
          />
        </g>
      </g>
    </svg>;
  }
}

const Icon = pure(Plus);
Icon.displayName = 'PlusIcon';
export default Icon;
